export default __webpack_public_path__ + "static/media/banner-home-768x1024.b3afb2c7.png";